import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-28 pb-20 min-h-screen bg-carnival-charcoal">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="section-padding"
        >
          <h1 className="text-5xl font-display text-white mb-12 text-center">
            {t('legalTitle')}
          </h1>

          <div className="max-w-4xl mx-auto space-y-8 text-white/80">
            <section>
              <p className="mb-6">{t('legalIntro')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('publisherTitle')}</h2>
              <p className="mb-2">{t('publisherDescription')}</p>
              <div className="space-y-2 pl-4">
                <p>{t('publisherWebmaster')}</p>
                <p>{t('publisherPhone')}</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('dataProcessingTitle')}</h2>
              <p className="mb-4">{t('dataProcessingDesc1')}</p>
              <p className="mb-4">{t('dataProcessingDesc2')}</p>
              <p>{t('dataProcessingDesc3')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('cookiesTitle')}</h2>
              <p className="mb-4">{t('cookiesDesc1')}</p>
              <p className="mb-4">{t('cookiesDesc2')}</p>
              <p className="mb-4">{t('cookiesDesc3')}</p>
              <p>{t('cookiesDesc4')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('dataRetentionTitle')}</h2>
              <p>{t('dataRetentionDesc')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('telemarketingTitle')}</h2>
              <p className="mb-4">{t('telemarketingDesc1')}</p>
              <p>{t('telemarketingDesc2')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('rightsTitle')}</h2>
              <p className="mb-4">{t('rightsDescription')}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t('rightInfo')}</li>
                <li>{t('rightCorrection')}</li>
                <li>{t('rightDeletion')}</li>
                <li>{t('rightLimitation')}</li>
                <li>{t('rightPortability')}</li>
                <li>{t('rightRevocation')}</li>
                <li>{t('rightOpposition')}</li>
              </ul>
              <p className="mt-4">{t('rightsContact')}</p>
            </section>
          </div>
        </motion.div>
      </div>
  );
};

export default LegalNotice;